module.exports = __webpack_public_path__ + "static/media/oval.be00fc4a.svg";